
import { setPageHeader } from '@/core/helpers/toolbar';
import { defineComponent, onBeforeUnmount, onMounted, ref, watchEffect } from 'vue';
import PromotionList from '../components/PromotionList.vue';
import PromotionForm from '../components/PromotionForm.vue';

export default defineComponent({
    name: 'promotions',
    components: {
        PromotionList,
        PromotionForm
    },
    setup() {
        const tabsValue = ref(0);
        const serviceTab = ref(false);
        const promotionType = ref('PRODUCT');

        const pageHeader = (title: string) => {
            setPageHeader({
                title,
                actionButton: {
                    ability: 'view_setting',
                    pageAction: {
                        action: 'addPromotionAction'
                    },
                    button: {
                        title: 'message.ADD message.PROMOTION',
                        icon: 'bi bi-plus',
                        openModal: true
                    }
                },
                breadCrumbs: [
                    { name: 'message.HOME', link: '/dashboard' },
                    { name: 'message.SYSTEM', link: '#' },
                    { name: 'message.SETTINGS', link: '/system/settings' },
                    { name: title }
                ]
            });
        };

        const scrollParents = () => [document.querySelector('#kt_content'), document.querySelector('.post'), document.querySelector('.custom-container')];

        onMounted(() => {
            scrollParents().forEach(element => element?.classList.add('promotions-scroll-bounds'));
        });

        onBeforeUnmount(() => {
            scrollParents().forEach(element => element?.classList.remove('promotions-scroll-bounds'));
        });

        watchEffect(() => {
            if (tabsValue.value == 0) {
                promotionType.value = 'PRODUCT';
                pageHeader('message.PRODUCT_PROMOTION');
            } else {
                serviceTab.value = true;
                promotionType.value = 'SERVICE';
                pageHeader('message.SERVICE_PROMOTION');
            }
        });

        return {
            tabsValue,
            serviceTab,
            promotionType
        };
    }
});
